'use strict';

module.exports = {

    /**
     * Appends theatMetrix script to the body of the page
     * @param {string} options.deviceId users deviceId
     * @param {string} options.pageId pageId to send to threatmetrix
     * @param {string} options.orgId orgId to send to threatmetrix
     */
    appendThreatMetrixToBody: function appendThreatMetrixToBody(options) {
        var deviceId = options.deviceId;
        var pageId = options.pageId;
        var orgId = options.orgId;

        var s = document.createElement("script");
        s.type = 'text/javascript';
        s.src = 'https://h.online-metrix.net/fp/tags.js?org_id=' + orgId + '&session_id=' + deviceId + '&pageid=' + pageId;
        document.body.appendChild(s);
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/ThreatMetrix.js
// module id = 846
// module chunks = 0